module.exports = __webpack_public_path__ + "static/img/14000272.7ce520ff.png";